import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'check-in':
        return { name: 'LogIn', color: 'text-success' };
      case 'check-out':
        return { name: 'LogOut', color: 'text-error' };
      case 'maintenance':
        return { name: 'Wrench', color: 'text-warning' };
      case 'alert':
        return { name: 'AlertTriangle', color: 'text-error' };
      default:
        return { name: 'Activity', color: 'text-muted-foreground' };
    }
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffMins < 1440) return `${Math.floor(diffMins / 60)}h ago`;
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 h-full">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Live Activity Feed</h3>
          <p className="caption text-muted-foreground mt-1">Recent updates</p>
        </div>
        <div className="flex items-center gap-2 px-3 py-1.5 bg-success/10 text-success rounded-full">
          <div className="w-2 h-2 rounded-full bg-success animate-pulse"></div>
          <span className="text-xs font-medium">Live</span>
        </div>
      </div>
      <div className="space-y-3 overflow-y-auto max-h-[600px] pr-2">
        {activities?.map((activity) => {
          const icon = getActivityIcon(activity?.type);
          return (
            <div
              key={activity?.id}
              className="flex gap-3 p-3 rounded-lg bg-muted/50 hover:bg-muted transition-smooth"
            >
              <div className={`flex items-center justify-center w-8 h-8 rounded-full bg-background ${icon?.color}`}>
                <Icon name={icon?.name} size={16} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground mb-1">
                  {activity?.title}
                </p>
                <p className="text-xs text-muted-foreground line-clamp-2">
                  {activity?.description}
                </p>
                <div className="flex items-center gap-2 mt-2">
                  <Icon name="MapPin" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{activity?.location}</span>
                </div>
              </div>
              <span className="text-xs text-muted-foreground whitespace-nowrap">
                {formatTime(activity?.timestamp)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityFeed;